import apisauce from 'apisauce';

import { SERVER_BASE_URL } from '@/shared/config/routes-config';
import { ResponseModel } from '@/shared/interfaces/response-model.interface';
import {
  getSessionCorrelationId,
  getUserAccessToken
} from '@/shared/services/helpers/auth-helper/auth-helper.service';
import { attachImpersonationHeader } from '@/shared/services/helpers/impersonation/impersonation-helper.service';

export interface ImpersonationRefreshResponse {
  impersonationSessionId: string;
  accessToken: string;
  tokenExpiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  email: string;
  name: string;
  userId: string;
  role?: string[];
}

// Standalone client — avoids circular import with http.config interceptors
const impersonationRefreshApi = apisauce.create({
  baseURL: SERVER_BASE_URL,
  headers: {
    'X-Client-Platform': 'internal_admin',
    'X-Client-Type': 'web',
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  timeout: 240000
});

export async function refreshImpersonationSession(
  sessionId: string,
  refreshToken: string
): Promise<ImpersonationRefreshResponse> {
  const headers: Record<string, string> = {};

  const accessToken = getUserAccessToken();
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  const correlationId = getSessionCorrelationId();
  if (correlationId) headers['x-session-id'] = correlationId;

  attachImpersonationHeader(headers);

  const response = await impersonationRefreshApi.post<ResponseModel<ImpersonationRefreshResponse>>(
    '/auth/impersonation/refreshToken',
    { sessionId, refreshToken },
    { headers }
  );

  if (!response.ok || !response.data?.data) {
    throw new Error(
      response.data?.message || response.problem || 'Failed to refresh impersonation session'
    );
  }

  return response.data.data;
}
